import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaChartLine, FaShieldAlt, FaUsers, FaRocket } from 'react-icons/fa';

const WhyJoinUs = () => {
    const { t } = useTranslation();
    return (
        <div className="why-join-us">
            <div className="why-join-us-content">
                <div className="why-join-header">
                    <h2 className="why-join-us-title">{t('whyJoin.title')}</h2>
                    <p className="why-join-us-subtitle">{t('whyJoin.subtitle')}</p>
                </div>

                <div className="why-join-features">
                    <div className="why-join-feature">
                        <div className="why-join-feature-number mx-3">01</div>
                        <div className="why-join-feature-icon">
                            <FaChartLine size={32} />
                        </div>
                        <h4 className="why-join-feature-title">{t('whyJoin.c1Title')}</h4>
                        <p className="why-join-feature-text">{t('whyJoin.c1Text')}</p>
                    </div>

                    <div className="why-join-feature">
                        <div className="why-join-feature-number">02</div>
                        <div className="why-join-feature-icon">
                            <FaShieldAlt size={32} />
                        </div>
                        <h4 className="why-join-feature-title">{t('whyJoin.c2Title')}</h4>
                        <p className="why-join-feature-text">{t('whyJoin.c2Text')}</p>
                    </div>

                    <div className="why-join-feature">
                        <div className="why-join-feature-number">03</div>
                        <div className="why-join-feature-icon">
                            <FaUsers size={32} />
                        </div>
                        <h4 className="why-join-feature-title">{t('whyJoin.c3Title')}</h4>
                        <p className="why-join-feature-text">{t('whyJoin.c3Text')}</p>
                    </div>

                    <div className="why-join-feature">
                        <div className="why-join-feature-number">04</div>
                        <div className="why-join-feature-icon">
                            <FaRocket size={32} />
                        </div>
                        <h4 className="why-join-feature-title">{t('whyJoin.c4Title')}</h4>
                        <p className="why-join-feature-text">{t('whyJoin.c4Text')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhyJoinUs;
